import { render, staticRenderFns } from "./Demonstrate.vue?vue&type=template&id=3e5ddf60&scoped=true&"
import script from "./Demonstrate.vue?vue&type=script&lang=js&"
export * from "./Demonstrate.vue?vue&type=script&lang=js&"
import style0 from "./Demonstrate.vue?vue&type=style&index=0&id=3e5ddf60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5ddf60",
  null
  
)

export default component.exports